import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '../../../public/img/logo.svg'


const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-center bg-[#390261] text-white"
}
const _hoisted_2 = { class: "flex flex-1 items-center justify-center" }
const _hoisted_3 = {
  key: 0,
  class: "p-2 font-medium",
  href: "https://dnsfordevelopers.com/"
}
const _hoisted_4 = {
  key: 1,
  class: "p-2 font-medium",
  href: "https://dnsfordevelopers.com/"
}
const _hoisted_5 = { class: "flex flex-col justify-between items-center shadow-sm bg-white text-gray-800 border-b border-gray-200 sm:flex-row sm:gap-3" }
const _hoisted_6 = {
  class: "w-full max-w-lg px-3 sm:pl-0 pd:pr-0",
  autocomplete: "off"
}
const _hoisted_7 = { class: "w-80 min-w-fit pr-2 whitespace-nowrap text-right hidden md:inline" }

import { useStore } from 'vuex';
import { PropType, computed } from 'vue';
import { useRouter } from 'vue-router';
import DomainSearch from '@/components/DomainSearch.vue';
import { domainNameToUrlPath } from '@/common/domainName';
import { XMarkIcon } from '@heroicons/vue/24/outline';


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  props: {
  domain: {
    type: String,
    default: undefined,
  },
  domainSearchToUrl: {
    type: Function as PropType<(encodedDomain: string) => string>,
    default: undefined,
  },
  searchButtonText: {
    type: String,
    default: undefined,
  },
  autocompleteEnabled: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;

const courseIsOnSale = computed(
  () => new Date(new Date(2025, 6, 11).toDateString()) > new Date(new Date().toDateString()),
);

const router = useRouter();

const store = useStore();
const toggleBanner = () => store.commit('toggleBanner');
const showBanner = computed(() => store.state.showBanner);

function redirectTo(newDomain: string): void {
  if (props.domainSearchToUrl) {
    router.push(props.domainSearchToUrl(newDomain));
  } else {
    // Vue acts up when setting this as a default prop
    router.push(`/domains/${domainNameToUrlPath(newDomain)}/dns-records/`);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showBanner.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, [
            (courseIsOnSale.value)
              ? (_openBlock(), _createElementBlock("a", _hoisted_3, [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("span", { class: "m-5" }, "🎁", -1),
                  _createTextVNode("I'm turning 35! Get 35% off my DNS for Developers course.", -1),
                  _createElementVNode("span", { class: "m-5" }, "🎁", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("a", _hoisted_4, "DNS for Developers (video course) ✨ Black Friday Sale ✨"))
          ]),
          _createElementVNode("span", {
            class: "justify-self-end p-2 cursor-pointer",
            onClick: toggleBanner
          }, [
            _createVNode(_unref(XMarkIcon), { class: "h-5 w-5" })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "mx-auto mt-4 min-w-fit pl-6 sm:m-0 sm:w-80"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "NsLookup logo",
            width: "142",
            height: "24",
            class: "inline"
          }, null, -1)
        ]))]),
        _: 1
      }),
      _createElementVNode("form", _hoisted_6, [
        _createVNode(DomainSearch, {
          prefill: __props.domain,
          onSubmitted: redirectTo,
          "button-text": __props.searchButtonText,
          "autocomplete-enabled": __props.autocompleteEnabled
        }, null, 8, ["prefill", "button-text", "autocomplete-enabled"])
      ]),
      _createElementVNode("nav", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: "/learning/",
          class: "p-3 text-dark"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("Learning", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/install/",
          class: "p-3 text-dark hidden lg:inline"
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("Browser extension", -1)
          ]))]),
          _: 1
        }),
        _cache[4] || (_cache[4] = _createElementVNode("a", {
          href: "https://www.whoisfreaks.com/",
          rel: "noopener",
          class: "p-3 text-dark"
        }, [
          _createElementVNode("span", { class: "hidden xl:inline" }, "DNS lookup"),
          _createTextVNode(" API ")
        ], -1))
      ])
    ])
  ], 64))
}
}

})